require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-masonry-house-domain-article.json") })
        }
      }, "path---news-masonry-house-domain-article");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-masonry-house-domain-article!./.cache/json/news-masonry-house-domain-article.json
// module id = 827
// module chunks = 231608221292675